/* eslint-disable multiline-comment-style */
/* eslint-disable max-len */
import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import { IUpdateExcelItem, RuleListRes } from './types'


/** 规则列表 */
export const getRulePackageList = (param: {pageNo: number, pageSize: number}) => request.get<RuleListRes>(`${HOSTS.BASE}/api/entweb/rulePackage/list`, { params: param })

/** 删除规则 */
export const deleteRulePackage = (rulePackageId: number) => request.post(`${HOSTS.BASE}/api/entweb/rulePackage/delete`, { rulePackageId })


interface IUploadExcelParams {
  /** 文件，说明：content-type需要是multipart/form-data */
  byteBuffer: Blob;
  /** //1:预算导入新增；2. 预算导入更新 */
  importType?: '1' | '2';
  /** 规则包ID */
  rulePackageId?: string;
  fileName?: string
}
/** 上传Excel */
export const budgetImportExcel = (params: IUploadExcelParams) => request.post<string>(
  `${HOSTS.BASE}/api/entweb/budget/importData`,
  params,
  { headers: { 'Content-Type': 'multipart/form-data' } }
)

/** 轮询结果 */

// /api/entweb/budget/queryAsyncResult

export const fetchExcelAsyncResult = (token: string) => request.get<{fileUrl: string}>(`${HOSTS.BASE}/api/entweb/budget/queryAsyncResult`, { params: { token } })

/** 预算-导出文件
 * 1001：预算费用导入模版、1003：预算额度下载、1004：员工余额更新模版
 * */
// eslint-disable-next-line max-len
export const fetchExcelFile = (params: {type: 1001 | 1003 | 1004, rulePackageId?: string}) => request.get<{fileURL?: string, taskToken?: string}>(`${HOSTS.BASE}/api/entweb/budget/file/download`, { params })


/** 费用更新列表 */
export const fetchExcelUpdateLog = (param: {pageNo: number, pageSize: number, rulePackageId: string}) => request.get<{result: IUpdateExcelItem[]}>(`${HOSTS.BASE}/api/entweb/budget/task/adjust/list`, { params: param })